import React, { InputHTMLAttributes, RefObject, useMemo } from 'react'
import { Form, Input } from 'antd'
import dp from 'dot-prop-immutable'
import Password, { PasswordProps } from 'antd/lib/input/Password'
import { FormikProps } from 'formik'
import { FormItemProps } from 'antd/lib/form'

import { useT } from 'src/core/hooks/use-translation'

import { WrapIcon } from './styles'

type Props = PasswordProps &
  Pick<InputHTMLAttributes<HTMLInputElement>, 'autoFocus'> &
  FormItemProps & {
    formikProps: FormikProps<any>
    innerRef?: RefObject<Password>
  }

function InputPassword({
  autoFocus = false,
  formikProps,
  innerRef,
  label,
  name,
  placeholder,
  prefix = <WrapIcon type="lock" />,
  required = true,
  size = 'large'
}: Props) {
  const { t } = useT()
  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])

  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])

  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  return (
    <Form.Item
      colon={false}
      hasFeedback
      help={touched && typeof error === 'string' ? t(error) : ''}
      label={t(label)}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
    >
      <Input.Password
        allowClear={!required}
        autoFocus={autoFocus}
        name={name}
        onBlur={formikProps.handleBlur}
        onChange={formikProps.handleChange}
        placeholder={t(placeholder)}
        prefix={prefix}
        ref={innerRef}
        size={size}
        value={value}
      />
    </Form.Item>
  )
}

export default InputPassword
